// Please keep alphabetized
export enum IconType {
  Default,
  Image
}